export const SETTINGS_VIEWS = [
  "clinic",
  "dashboard",
  "website",
  "translations",
  "assistant",
  "permissions",
  "audit",
] as const;

export const SETTINGS_INNER_PARAMS = [
  "tab",
  "role",
  "section",
  "changed",
  "trigger",
  "outcome",
  "status",
  "page",
  "perPage",
];
